import { render } from "./form6.vue?vue&type=template&id=c6764888&scoped=true"
import script from "./form6.vue?vue&type=script&lang=js"
export * from "./form6.vue?vue&type=script&lang=js"

import "./form6.vue?vue&type=style&index=0&id=c6764888&lang=less&scoped=true"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6764888"]])

export default __exports__